export const getCardType = (number) => {
    const re = {
        visa: /^4/,
        mastercard: /^5[1-5]|^2[2-7]/,
        amex: /^3[47]/,
        discover: /^6(?:011|5)/,
        jcb: /^(?:2131|1800|35)/,
        diners: /^3(?:0[0-5]|[68])/,
        maestro: /^(?:5018|5020|5038|6304|6759|6761|6763)/,
    };

    for (const key in re) {
        if (re[key].test(number)) {
            return key;
        }
    }

    return 'unknown';
};

export const formatCardNumber = (value) => {
    const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
    const matches = v.match(/\d{4,16}/g);
    const match = (matches && matches[0]) || '';
    const parts = [];

    for (let i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4));
    }

    if (parts.length) {
        return parts.join(' ');
    } else {
        return v;
    }
};

export const formatExpiryDate = (value) => {
    const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
    if (v.length >= 2) {
        return v.substring(0, 2) + (v.length > 2 ? ' / ' + v.substring(2, 4) : '');
    }
    return v;
};
